import CompLayout from "@/pcomponents/comp/layout/layout";
import { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import getXcolumnJson from "./xcolumn/list";
import ListAggrid from '@/pcomponents/common/crud/list/aggrid/list';
import my_axios,{ get_axios_data } from "@/pcomponents/common/axios";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import DateFunc from '@/lib/lyg/date_func';
import strFunc from '@/lib/lyg/string';
import { useSelector, useDispatch } from 'react-redux';
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';
import SearchArea from "./area/search";

function ListPage(){
  let user=useSelector((state:any) => state.user);
  const xColumnArr=getXcolumnJson();
  const listAggridRef= useRef<any>();
  const [pageData, setPageData] = useState({
    listOpt:{
      ...xColumnArr.list_opt,
      s_grade:'',
    }
  });
  const [infoArr, setInfoArr] = useState([]);
  const [countInfo, setCountInfo] = useState({"tot":0});
  let select_stu_grade_option_arr=XcolumnFunc.getSortByTableKey({'table':'user','key':'a_stu_grade'});

  useEffect(() => {
    
  }, [user]);

  const list = (inOptObj:any)=>{
    if(user.comp_seq==""){
      return false;
    }
    if(inOptObj!=undefined){
      let tmpPageData=pageData;
      inOptObj["sc"]=listAggridRef.current.getListSc();
      for(let key in tmpPageData.listOpt){
        if(inOptObj[key]!=undefined){
          tmpPageData.listOpt[key]=inOptObj[key];
        }
      }
      setPageData({...tmpPageData});
    }
    my_axios.post( process.env.REACT_APP_API_URL+'/api/comp/basic/user/user_removed/list',pageData.listOpt,get_axios_data())
    .then((response) => {
      if(response.data["result"]==="true"){
        setInfoArr(response.data["data"]["info_arr"]);
        setCountInfo(response.data["data"]["count_info"]);
        listAggridRef.current.setInfoArr(response.data["data"]["info_arr"]);
      }else{
        
      }
    });
  };

  const restore_remove_user=()=>{
    let selected_row=listAggridRef.current.getSelectedRows();
    if(selected_row.length===0){
      alert("선택없음.");
      return false;
    }
    let removed_seq_arr=[];
    for(let i=0;i<selected_row.length;i++){
      removed_seq_arr.push(selected_row[i]["a_remove_seq"]);
    }

    if(!confirm("선택 회원을 복구 하시겠습니까?")){
      return false;
    }

    let req_from_json_data={
      "removed_seq_arr":removed_seq_arr
    };
    my_axios.post( process.env.REACT_APP_API_URL+'/api/comp/basic/user/user_removed/restore',req_from_json_data,get_axios_data())
    .then((response) => {
      if(response.data["result"]==="true"){
        alert(response.data["msg"]);
        list({});
      }else{
        alert(response.data["msg"]);
      }
    });
  };

  const goDelete = useCallback( (e:any) => {
    let selected_row=listAggridRef.current.getSelectedRows();
    if(selected_row.length===0){
      alert("선택없음.");
      return false;
    }
    if(!confirm("삭제하시겠습니까?")){
      return false;
    }
    let del_form_data={
      "data_arr":selected_row
    };
    my_axios.post( process.env.REACT_APP_API_URL+'/api/comp/basic/user/user_removed/delete',del_form_data,get_axios_data())
    .then((response) => {
      if(response.data["result"]==="true"){
        alert(response.data["msg"]);
        list({});
      }else{
        alert(response.data["msg"]);
      }
    });
  }, []);

  const cellClickedListener = useCallback( (params:any) => {
    var key=params.colDef.field;
    
  }, []);

  const cellRenderer= useCallback( (params:any) => {
    var key=params.colDef.field;
    var render_str=params.value;

    if(key=="a_stu_grade"){
      let tmp_opt_len=select_stu_grade_option_arr.length;
      for(let i=0;i<tmp_opt_len;i++){
        if(select_stu_grade_option_arr[i]["value"]==render_str){
          render_str=select_stu_grade_option_arr[i]["text"];
        }
      }
    }
   
    return render_str;
  }, []);

  return (
    <CompLayout>
      <div className="con_wrap">
        <div className="btn-box-left relative h-8">
          <SearchArea
            listOpt={pageData.listOpt}
            list={list}
          ></SearchArea>
          <div className="absolute right-0 top-0 btn-box-right">
            {user.user_grade=="master"&&
              <div>
                <button className="btn btn-sky" onClick={()=>{restore_remove_user();}}>복구</button>
                <button className="btn btn-red ml-1" onClick={goDelete}>삭제</button>
              </div>
            }
          </div>
        </div>
        <ListAggrid
        ref={listAggridRef}
        infoArr={infoArr}
        xColumnArr={{...xColumnArr}}
        list={list}
        gridOpt={{
          fix_left_num:xColumnArr.list_opt_arr.fix_left_num,
          is_idx_num:true,
          is_add_checkbox:true,
          floatingFilter:true,
          onGridReady:()=>{
            list({});
          },
          onCellClicked:cellClickedListener,
          cellRenderer:cellRenderer
        }}
        ></ListAggrid>
        <Paging now_page={pageData.listOpt.now_page}
          num_per_page={pageData.listOpt.num_per_page}
          total_rec={countInfo.tot} 
          onChangePage={(now_page:number)=>{list({now_page:now_page});}}
          onChangeNumPerPage={(num_per_page:number)=>{list({num_per_page:num_per_page,now_page:1});}}></Paging>
      </div>
    </CompLayout>
  );
}

export default ListPage;